import { useEffect, useState } from 'react';
import {
    Autocomplete,
    debounce,
    MenuItem,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { $autocompleteSearch, searchItemFx } from './store';
import { useStore } from 'effector-react';

export default function AutocompleteSearch(props) {
    const [inputValue, setInputValue] = useState('');
    const [noOptionsText] = useState('');

    const searchItems = useStore($autocompleteSearch);

    const { setValue, watch } = useFormContext();
    const selectedSearch = searchItems[props.url] || [];

    const defaultValue = watch(props.name);

    useEffect(() => {
        setTimeout(() => {
            if (typeof props.defaultValue === 'object') {
                searchItemFx({
                    key: props.url,
                    value: props.defaultValue?.name
                });
                setValue(props.name, props.defaultValue?.id);
                setInputValue(props.defaultValue?.name || '');
            }
        }, 500);
    }, [props.defaultValue, props.name, props.url, setValue]);

    const handleInput = debounce((event) => {
        const inputValue = event.target.value;

        searchItemFx({
            key: props.url,
            value: inputValue
        });

        setInputValue(inputValue || '');
    }, 500);

    const handleChange = (event) => {
        const itemId = Number(event.currentTarget.getAttribute('data-id'));
        const item = selectedSearch.find((item) => item.id === itemId);

        setInputValue(item?.name || '');

        if (props.isOnlyId) {
            setValue(props.name, itemId);
            return;
        }

        setValue(props.name, item);
    };

    if (props.type === 'view') {
        return (
            <Stack>
                <Typography variant="h6">{props.title}</Typography>
                <Typography variant="subtitle1">
                    {typeof props.defaultValue === 'object'
                        ? props.defaultValue.name
                        : 'не указано'}
                </Typography>
            </Stack>
        );
    }

    return (
        <Stack spacing="4px" alignItems="flex-start">
            <Typography variant="subtitle1" fontWeight="500">
                {`${props.title}:`}
            </Typography>
            <Autocomplete
                value={
                    selectedSearch?.find((item) => item.id === defaultValue)
                        ?.name ||
                    inputValue ||
                    ''
                }
                noOptionsText={noOptionsText}
                options={selectedSearch?.map((item) => item.name) || []}
                size="small"
                onChange={handleChange}
                clearOnBlur={false}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        onInput={handleInput}
                        sx={{
                            minWidth: '360px',
                            fontSize: '10px'
                        }}
                        {...props}
                    />
                )}
                renderOption={(params, option) => {
                    return (
                        <MenuItem
                            {...params}
                            key={JSON.stringify(option)}
                            data-id={
                                selectedSearch?.find(
                                    (item) => item.name === option
                                )?.id
                            }
                        >
                            {option}
                        </MenuItem>
                    );
                }}
            />
        </Stack>
    );
}
